import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/shared";
import { ReconDashboard } from "./Dashboard";
import { ItemsQueue } from "./Items";
import { CreditRecovery } from "./Credit";
import { EValue } from "./EValue";
import { Vendors } from "./Vendors";
import { PayoutRecon } from "./Payouts";
import { NetworkRecon } from "./Network";
import { Adjustments, ReconAudit } from "./Adjustments";

const TABS = [
  ["dashboard", "Dashboard"], ["queues", "Open Items"], ["credit", "Credit Recovery"], ["evalue", "E-value / Bank"], ["vendors", "Vendors"],
  ["payouts", "Payout Recon"], ["network", "Network & Funding"], ["adjustments", "Adjustments"], ["audit", "Audit Log"],
];

export default function ReconPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "dashboard";
  const [meta, setMeta] = useState(null);
  useEffect(() => { api.get("/admin/recon/meta").then(({ data }) => setMeta(data)); }, []);
  const go = (t, extra = {}) => setParams({ tab: t, ...extra });
  if (!meta) return <div className="text-sm text-slate-400">Loading…</div>;
  const props = { meta, go, params };
  return (
    <div data-testid="recon-page">
      <PageHeader title="Reconciliation" subtitle="Every rupee matched across company bank, internal ledger and vendor. Unmatched items stay open until resolved with a reason and evidence." />
      <div className="mb-5 flex flex-wrap gap-1 rounded-lg border border-slate-200 bg-white p-1" data-testid="recon-tabs">
        {TABS.map(([v, l]) => (
          <button key={v} onClick={() => go(v)} className={`rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${tab === v ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`} data-testid={`recon-tab-${v}`}>{l}</button>
        ))}
      </div>
      {tab === "dashboard" && <ReconDashboard {...props} />}
      {tab === "queues" && <ItemsQueue {...props} />}
      {tab === "credit" && <CreditRecovery {...props} />}
      {tab === "evalue" && <EValue {...props} />}
      {tab === "vendors" && <Vendors {...props} />}
      {tab === "payouts" && <PayoutRecon {...props} />}
      {tab === "network" && <NetworkRecon {...props} />}
      {tab === "adjustments" && <Adjustments {...props} />}
      {tab === "audit" && <ReconAudit {...props} />}
    </div>
  );
}
